import { useState, useEffect } from 'react'
import { get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import FormLoader from '../../../../components/loader/FormLoader'
import { useNavigate } from 'react-router-dom'
import Pagination from '../../../../components/pagination/Pagination'
import FullLoader from '../../../../components/loader/FullLoader'

function Bookings() {
  const baseURL = (import.meta as any).env.VITE_BASE_URL
  const { notify } = useGlobalContext()
  const navigate = useNavigate()
  const [bookings, setBookings] = useState<any>({ data: [] })
  const [bookingsLoading, setBookingsLoading] = useState(true)
  const [paginationPage, setPaginationPage] = useState('default')

  function fetchBookings(page: number, pageSize: number) {
    setBookingsLoading(true)
    get(`booking/list?page=${page}&limit=${pageSize}`)
      .then((result: any) => {
        if (result.status === 200) {
          setBookings(result)
        } else {
          notify('error', result.message)
        }
        setBookingsLoading(false)
      })
      .catch(() => {
        setBookingsLoading(false)
      })
  }
  const fetchFilteredBookings = async (page: number, pageSize: number) => {
    setBookingsLoading(true)
    get(
      `booking/list?from=${dates.from}&to=${dates.to}&page=${page}&limit=${pageSize}`
    )
      .then((result: any) => {
        if (result.status === 200) {
          setBookings(result)
        } else {
          notify('error', result.message)
        }
        setBookingsLoading(false)
      })
      .catch(() => {
        setBookingsLoading(false)
      })
  }
  useEffect(() => {
    fetchBookings(1, 10)
  }, [])

  //Filter
  const [dates, setDates] = useState({
    from: '',
    to: '',
  })
  const handleChange = (e: any) => {
    const { name, value } = e.target
    setDates((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }
  function handleFilter() {
    if (!dates.from || !dates.to) {
      notify('error', `Dates can't be empty`)
    } else {
      setPaginationPage('date')
      fetchFilteredBookings(1, 10)
    }
  }

  //<----------- Download Excel and CSV --------------->
  const [downloading, setDownloading] = useState(false)

  const handleDownload = async (format: string) => {
    const token = sessionStorage.getItem('token')
    let apiUrl = `${baseURL}/booking/export?from=${dates.from}&to=${dates.to}&format=${format}`

    try {
      // Make an API request to fetch the Excel file
      setDownloading(true)
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          // Add any necessary headers, like authorization if required
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error('Failed to download file')
      }

      // Convert the response to a Blob
      const blob = await response.blob()

      // Extract the filename from the "Content-Disposition" header
      const fileName = `Bookings-${dates.from} to ${dates.to}`

      // Create a download link for the Blob
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName // Use the filename from the backend
      document.body.appendChild(a) // Append to the DOM
      a.click() // Trigger the download
      a.remove() // Clean up
      window.URL.revokeObjectURL(url) // Release memory
      setDownloading(false)
    } catch (error) {
      console.error('Error downloading the file:', error)
    }
  }

  return (
    <div className='home'>
      {downloading && <FullLoader />}
      <div className='home_tag flex justify-between items-center'>
        <h1></h1>
        <div className='flex items-center select-wrapper'>
          <div className='flex items-center'>
            <input
              type='date'
              name='from'
              value={dates.from}
              onChange={handleChange}
              max={new Date().toISOString().split('T')[0]}
            />
          </div>
          <div className='flex items-center'>
            <p>to</p>
            <input
              type='date'
              name='to'
              value={dates.to}
              onChange={handleChange}
              min={dates.from}
              max={new Date().toISOString().split('T')[0]}
            />
          </div>

          <button disabled={!dates.from || !dates.to} onClick={handleFilter}>
            filter
          </button>
        </div>
      </div>
      <div className='home_tables'>
        <div className='left'>
          {bookingsLoading ? (
            <FormLoader position='center' />
          ) : (
            <>
              <div className='flex justify-between  search-btns flex-wrap'>
                <div className='search '></div>

                {paginationPage === 'date' && (
                  <div className='buttons flex'>
                    <button onClick={() => handleDownload('csv')}>
                      Export CSV
                    </button>
                    <button onClick={() => handleDownload('excel')}>
                      Export EXCEL
                    </button>
                  </div>
                )}
              </div>
              {bookings.data.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {bookings.data.map((item: any, i: number) => (
                      <div
                        className='card'
                        onClick={() =>
                          navigate(`/aggregator/booking/${item._id}`)
                        }
                      >
                        <div className='flex justify-between row'>
                          <div className='count flex items-center justify-center'>
                            {i + 1}
                          </div>
                          <p> {new Date(item.createdAt).toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Amount</h4>
                          <p>₦{item.charge.toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Tracking ID</h4>
                          <p>{item.trackingId}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Delivery type</h4>
                          <p>{item.deliveryType}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Status</h4>
                          <span className={`chip ${item.booking_status.code}`}>
                            {item.booking_status.description}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Date/Time</th>
                        <th>Amount</th>
                        <th>Tracking ID</th>
                        <th>Delivery Type</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookings.data.map((item: any, i: number) => (
                        <tr key={item._id}>
                          <td>{i + 1}</td>
                          <td className='count'>
                            {new Date(item.createdAt).toLocaleString()}
                          </td>
                          <td className='count'>
                            NGN {item.charge.toLocaleString()}
                          </td>
                          <td className='count'>{item.trackingId}</td>
                          <td className='count'>{item.deliveryType}</td>
                          <td>
                            <span
                              className={`chip ${item.booking_status.code}`}
                            >
                              {item.booking_status.description}
                            </span>
                          </td>
                          <td>
                            <span
                              onClick={() =>
                                item.isFloating
                                  ? navigate(
                                      `/aggregator/floating-booking/${item._id}`
                                    )
                                  : navigate(`/aggregator/booking/${item._id}`)
                              }
                              className='view'
                            >
                              view
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={bookings.pagination.page}
                    totalCount={bookings.pagination.totalPages}
                    pageSize={bookings.pagination.limit}
                    onPageChange={(page: number, pageSize: number) => {
                      paginationPage === 'default'
                        ? fetchBookings(page, pageSize)
                        : fetchFilteredBookings(page, pageSize)
                    }}
                  />
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='majesticons:book-line' />
                    <h1>No Bookings To Show</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Bookings
